var map = {
	"./cat.svg": "3e07",
	"./projects.svg": "18d6",
	"./skills.svg": "5a9e",
	"./skills/c++.svg": "e8c1",
	"./skills/css.svg": "3542",
	"./skills/expressjs.svg": "0ad3",
	"./skills/firebase.svg": "9196",
	"./skills/firefox.svg": "e0a4",
	"./skills/flutter.svg": "08ea",
	"./skills/html.svg": "a3e6",
	"./skills/java.svg": "b7b9",
	"./skills/javascript.svg": "a1d0",
	"./skills/mongodb.svg": "225f",
	"./skills/postgressql.svg": "b4e0",
	"./skills/python.svg": "e736",
	"./skills/pytorch.svg": "8037",
	"./skills/react.svg": "f3c0",
	"./skills/svelte.svg": "c6ea",
	"./skills/vuejs.svg": "5d27",
	"./talk.svg": "a18c",
	"./who.svg": "ef5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";